(() => {
  if (window.__featuredProductsInit) return;
  window.__featuredProductsInit = true;

  const SECTION_SELECTOR = '.featured-products';

  const initCarousel = (root) => {
    if (!root || root.dataset.swiperInit === 'true') return;
    if (typeof Swiper === 'undefined') return;

    const container = root.querySelector('.featured-products__swiper');
    if (!container) return;

    const disableDesktop = root.dataset.disableCarouselDesktop === 'true';

    new Swiper(container, {
      slidesPerView: 1.4,
      spaceBetween: 16,
      autoplay: { delay: 4000, disableOnInteraction: false },
      navigation: {
        prevEl: root.querySelector('.featured-products__nav--prev'),
        nextEl: root.querySelector('.featured-products__nav--next'),
      },
      breakpoints: {
        1024: disableDesktop
          ? { enabled: false }
          : { slidesPerView: 4.2, spaceBetween: 24 },
      },
    });

    root.dataset.swiperInit = 'true';
  };

  // swiper-bundle.js is deferred, so it may not be ready yet. Run cb once Swiper exists.
  const ensureSwiper = (cb) => {
    if (typeof Swiper !== 'undefined') { cb(); return; }
    let tries = 0;
    const timer = setInterval(() => {
      if (typeof Swiper !== 'undefined') { clearInterval(timer); cb(); }
      else if (++tries > 150) { clearInterval(timer); } // ~15s safety cap
    }, 100);
  };

  // Only instantiate Swiper when the section nears the viewport — keeps its cost off
  // the initial load (better TBT). Falls back to eager init without IntersectionObserver.
  const initWhenVisible = () => {
    const roots = [...document.querySelectorAll(SECTION_SELECTOR)];
    if (!roots.length) return;
    if (!('IntersectionObserver' in window)) {
      ensureSwiper(() => roots.forEach(initCarousel));
      return;
    }
    const io = new IntersectionObserver((entries, obs) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        obs.unobserve(entry.target);
        const root = entry.target;
        ensureSwiper(() => initCarousel(root));
      }
    }, { rootMargin: '300px 0px' });
    roots.forEach((root) => io.observe(root));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenVisible);
  } else {
    initWhenVisible();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target?.querySelector?.(SECTION_SELECTOR);
    if (root) ensureSwiper(() => initCarousel(root));
  });
})();
